import { render, staticRenderFns } from "./IframedForm.vue?vue&type=template&id=f5f1dbc8&"
import script from "./IframedForm.vue?vue&type=script&lang=js&"
export * from "./IframedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports